/* Panda Food 2.0, per-variant gallery.

   Shopify links exactly ONE image to a variant, so the buy box could only ever
   swap the main photo and slots 2-4 kept showing the previous colour. But the
   media is uploaded in runs: every variant's photos sit together, starting at
   the one image Shopify does link. Boxers run three or four images; socks run
   three images and a video, or two and two.

   Two things this has to get right, both checked against live data rather than
   assumed:

     1. variant.image.id is NOT product.media[].id. They are different id
        spaces and never match, on any product in this shop. The only reliable
        join is the image filename, which survives image_url transformation.

     2. variant.featured_image.position counts IMAGES only, while media.position
        counts images and videos together. On a product with videos the two
        drift apart, so position arithmetic silently hands a colour another
        colour's photos. Boxers have no videos, which is why position looked
        correct there. Filenames avoid the whole problem.

   Runs end at the next variant's start image, so a variant with two shots gets
   two, not two plus a borrowed one. */
(function () {
  var pdp = document.querySelector('[data-pf2-pdp]');
  if (!pdp) return;

  var stage = pdp.querySelector('[data-pf2-stage]');
  var thumbs = pdp.querySelector('[data-pf2-thumbs]');
  var idInput = pdp.querySelector('[data-pf2-variant-id]');
  var mapEl = pdp.querySelector('[data-pf2-variants]');
  var medEl = pdp.querySelector('[data-pf2-media]');
  if (!stage || !idInput || !mapEl || !medEl) return;

  var MAP = [], MEDIA = [];
  try {
    MAP = JSON.parse(mapEl.textContent) || [];
    MEDIA = JSON.parse(medEl.textContent) || [];
  } catch (e) { return; }
  if (!MEDIA.length) return;

  function fname(u) { return String(u || '').split('?')[0].split('/').pop(); }

  var at = {};
  MEDIA.forEach(function (m, i) {
    var f = fname(m.u);
    if (f && !(f in at)) at[f] = i;
  });

  var starts = {};
  MAP.forEach(function (v) { if (v.raw) starts[fname(v.raw)] = true; });

  function byId(id) {
    for (var i = 0; i < MAP.length; i++) {
      if (String(MAP[i].id) === String(id)) return MAP[i];
    }
    return null;
  }

  function runFor(v) {
    var i = at[fname(v.raw)];
    if (i === undefined) return v.img ? [{ t: 'i', u: v.img }] : [];
    var out = [];
    for (var j = i; j < MEDIA.length && out.length < 4; j++) {
      if (j > i && starts[fname(MEDIA[j].u)]) break;
      if (MEDIA[j].t === 'x') continue;
      out.push(MEDIA[j]);
    }
    /* a per-colour override replaces the linked photo but not the rest of the run */
    if (v.img && v.raw && v.img !== v.raw && out.length) out[0] = { t: 'i', u: v.img };
    return out;
  }

  var last = '';

  function paint() {
    var v = byId(idInput.value);
    if (!v) return;
    var shots = runFor(v);
    if (!shots.length) return;

    var key = shots.map(function (s) { return s.u; }).join('|');
    if (key === last) return;
    last = key;

    var h1 = pdp.querySelector('h1');
    var alt = (h1 ? h1.textContent.trim() : '').replace(/"/g, '&quot;');

    stage.innerHTML = shots.map(function (m, i) {
      var on = i === 0 ? ' show' : '';
      if (m.t === 'v') {
        /* preload none and no autoplay: the panel used to render as a black box
           while a 1080p file buffered. The poster carries the first frame. */
        return '<video class="pf2-v' + on + '" data-i="' + i + '" playsinline muted controls ' +
          'preload="none" poster="' + (m.p || '') + '"><source src="' + m.u + '" type="video/mp4"></video>';
      }
      return '<img class="' + (i === 0 ? 'show' : '') + '" data-i="' + i + '" src="' + m.u +
        '" alt="' + alt + '" width="1400" height="1400"' +
        (i === 0 ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') + '>';
    }).join('');

    if (thumbs) {
      /* a single shot needs no rail: one thumbnail reads as a broken row */
      thumbs.innerHTML = shots.length < 2 ? '' : shots.map(function (m, i) {
        var src = m.t === 'v' ? (m.p || '') : m.u;
        var label = m.t === 'v' ? 'Play video' : 'View image ' + (i + 1);
        return '<button type="button"' + (i === 0 ? ' class="active"' : '') +
          ' data-i="' + i + '" aria-label="' + label + '">' +
          '<img src="' + src + '" alt="" width="84" height="84" loading="eager" decoding="async">' +
          (m.t === 'v' ? '<span class="pf2-play" aria-hidden="true"></span>' : '') +
          '</button>';
      }).join('');
    }
  }

  /* one place that changes the shot, for the rail and for a swipe alike */
  function goTo(i) {
    i = String(i);
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-i') === i); });
    stage.querySelectorAll('img,video').forEach(function (el) {
      var on = el.getAttribute('data-i') === i;
      el.classList.toggle('show', on);
      /* never leave audio playing behind a photo */
      if (!on && el.tagName === 'VIDEO' && !el.paused) el.pause();
    });
  }

  /* delegated: the rail is rebuilt, so handlers bound to its buttons would die */
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-i]');
      if (!btn) return;
      goTo(btn.getAttribute('data-i'));
    });
  }

  /* Swipe between the shots on a touch screen. The photo follows the finger and
     the neighbour slides in beside it; let go past a fifth of the width (or with
     a flick) and it settles on the neighbour, otherwise it springs back. The
     stage is touch-action:pan-y on phones, so a vertical drag still scrolls the
     page natively and only a sideways one is handled here. The shots are
     stacked and cross-faded at rest, so during a drag the two involved are made
     opaque and moved with transforms, and everything inline is cleared once the
     move has landed so the stylesheet is back in charge. */
  (function () {
    var sx = 0, sy = 0, st = 0, dx = 0, axis = '', cur = null, nb = null, list = [], idx = 0, w = 0, busy = false;
    function shots() { return [].slice.call(stage.querySelectorAll('img,video')); }
    function place(el, x, anim) {
      if (!el) return;
      el.style.transition = anim ? 'transform .32s cubic-bezier(.22,.7,.2,1)' : 'none';
      el.style.opacity = '1';
      el.style.transform = 'translateX(' + x + 'px)';
    }
    function clear(el) {
      if (!el) return;
      el.style.transition = 'none';
      el.style.transform = '';
      el.style.opacity = '';
      void el.offsetWidth;
      el.style.transition = '';
    }
    stage.addEventListener('touchstart', function (e) {
      if (busy || e.touches.length !== 1) return;
      list = shots();
      if (list.length < 2) return;
      cur = stage.querySelector('.show');
      idx = list.indexOf(cur);
      if (idx < 0) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now();
      dx = 0; axis = ''; nb = null; w = stage.clientWidth;
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (!cur || busy) return;
      var x = e.touches[0].clientX - sx, y = e.touches[0].clientY - sy;
      if (!axis) {
        if (Math.abs(x) < 8 && Math.abs(y) < 8) return;
        axis = Math.abs(x) > Math.abs(y) ? 'x' : 'y';
      }
      if (axis !== 'x') return;
      var want = x < 0 ? list[idx + 1] : list[idx - 1];
      if (nb && nb !== want) clear(nb);
      nb = want || null;
      /* past either end: resist rather than reveal nothing */
      dx = nb ? x : x * 0.3;
      place(cur, dx, false);
      if (nb) place(nb, dx + (x < 0 ? w : -w), false);
    }, { passive: true });
    function end() {
      if (!cur || axis !== 'x') { cur = null; return; }
      var c = cur, n = nb, fast = Math.abs(dx) / Math.max(Date.now() - st, 1) > 0.5;
      var go = n && (Math.abs(dx) > w * 0.2 || (fast && Math.abs(dx) > 24));
      cur = null; busy = true;
      if (go) {
        var dir = dx < 0 ? -1 : 1;
        place(c, dir * w, true); place(n, 0, true);
        setTimeout(function () {
          [c, n].forEach(function (el) { el.style.transition = 'none'; });
          goTo(n.getAttribute('data-i'));
          clear(c); clear(n); busy = false;
        }, 330);
      } else {
        place(c, 0, true); if (n) place(n, dx < 0 ? w : -w, true);
        setTimeout(function () { clear(c); clear(n); busy = false; }, 330);
      }
    }
    stage.addEventListener('touchend', end);
    stage.addEventListener('touchcancel', end);
  })();

  /* Zoom. Click or tap the photo to open it full screen at full resolution.
     Desktop: click again to zoom to 2.5x where you clicked; the picture then
     follows the mouse, so moving the pointer is how you look around it.
     Touch: pinch or double-tap to zoom (up to 4x), drag to pan, swipe sideways
     between the shots when not zoomed, swipe down to close. Esc, the arrow keys
     and the close button all work. Photos only: a video keeps its own controls.
     Self-contained, so the styles are injected here rather than spread across
     the section stylesheet. */
  (function () {
    var css = '' +
      '.pf2-stage img{cursor:zoom-in}' +
      '.pf2-lb{position:fixed;inset:0;z-index:2147483000;background:rgba(251,247,240,.98);display:flex;flex-direction:column;' +
      'opacity:0;transition:opacity .25s ease;touch-action:none;-webkit-user-select:none;user-select:none}' +
      '.pf2-lb.on{opacity:1}' +
      '.pf2-lb-view{position:relative;flex:1;display:grid;place-items:center;overflow:hidden}' +
      '.pf2-lb-img{width:min(94vw,calc(100vh - 150px));height:min(94vw,calc(100vh - 150px));object-fit:contain;background:#fff;' +
      'border-radius:var(--radius-lg);box-shadow:0 30px 70px -40px rgba(12,50,33,.45);transform-origin:50% 50%;will-change:transform;cursor:zoom-in}' +
      '.pf2-lb.zoomed .pf2-lb-img{cursor:zoom-out;border-radius:0;box-shadow:none}' +
      '.pf2-lb-bar{display:flex;align-items:center;justify-content:center;gap:18px;padding:14px 20px calc(18px + env(safe-area-inset-bottom,0px))}' +
      '.pf2-lb .pf2-lb-btn{width:46px;height:46px;border-radius:50%;border:2px solid rgba(22,35,27,.16);background:#fff;color:#16231B;' +
      'display:grid;place-items:center;cursor:pointer;padding:0;transition:background .2s,border-color .2s,color .2s}' +
      '.pf2-lb .pf2-lb-btn:hover{background:#114D31;border-color:#114D31;color:#fff}' +
      '.pf2-lb .pf2-lb-btn:focus-visible{outline:3px solid #1B7A4C;outline-offset:3px}' +
      '.pf2-lb .pf2-lb-btn svg{width:20px;height:20px}' +
      '.pf2-lb .pf2-lb-x{position:absolute;top:calc(14px + env(safe-area-inset-top,0px));right:16px;z-index:2}' +
      '.pf2-lb-n{font:600 .9rem/1 "Hanken Grotesk",system-ui,sans-serif;color:#16231B;min-width:3.5em;text-align:center;font-variant-numeric:tabular-nums}' +
      '@media(max-width:720px){.pf2-lb .pf2-lb-nav{display:none}.pf2-lb-img{border-radius:var(--radius-md)}}' +
      '@media(prefers-reduced-motion:reduce){.pf2-lb{transition:none}}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var ICON = {
      x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
      l: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>',
      r: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>'
    };
    var lb = null, img, num, view, urls = [], at = 0, s = 1, tx = 0, ty = 0, back = null, isOpen = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function big(u) { return String(u).replace(/([?&])width=\d+/, '$1width=2400'); }
    function size() { return img.offsetWidth; }
    function clamp() {
      var m = (s - 1) * size() / 2;
      tx = Math.max(-m, Math.min(m, tx)); ty = Math.max(-m, Math.min(m, ty));
    }
    function apply(anim) {
      img.style.transition = anim && !reduce ? 'transform .28s cubic-bezier(.22,.7,.2,1)' : 'none';
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      lb.classList.toggle('zoomed', s > 1.01);
    }
    function reset(anim) { s = 1; tx = 0; ty = 0; apply(anim); }
    function zoomAt(ns, cx, cy, anim) {
      /* keep the point under the finger or pointer where it is */
      var r = view.getBoundingClientRect();
      var px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2);
      ns = Math.max(1, Math.min(4, ns));
      tx = px - (px - tx) * (ns / s); ty = py - (py - ty) * (ns / s);
      s = ns;
      if (s <= 1.01) { s = 1; tx = 0; ty = 0; }
      clamp(); apply(anim);
    }
    function show(i, dir) {
      at = (i + urls.length) % urls.length;
      reset(false);
      img.src = urls[at];
      num.textContent = (at + 1) + ' / ' + urls.length;
      if (dir && !reduce && img.animate) {
        img.animate([{ transform: 'translateX(' + (dir * 40) + 'px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
          { duration: 260, easing: 'ease-out' });
      }
    }
    function build() {
      lb = document.createElement('div');
      lb.className = 'pf2-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product images');
      lb.innerHTML = '<button type="button" class="pf2-lb-btn pf2-lb-x" aria-label="Close">' + ICON.x + '</button>' +
        '<div class="pf2-lb-view"><img class="pf2-lb-img" alt=""></div>' +
        '<div class="pf2-lb-bar"><button type="button" class="pf2-lb-btn pf2-lb-nav" data-d="-1" aria-label="Previous image">' + ICON.l + '</button>' +
        '<span class="pf2-lb-n" aria-live="polite"></span>' +
        '<button type="button" class="pf2-lb-btn pf2-lb-nav" data-d="1" aria-label="Next image">' + ICON.r + '</button></div>';
      document.body.appendChild(lb);
      img = lb.querySelector('.pf2-lb-img');
      num = lb.querySelector('.pf2-lb-n');
      view = lb.querySelector('.pf2-lb-view');
      lb.querySelector('.pf2-lb-x').addEventListener('click', close);
      lb.querySelectorAll('.pf2-lb-nav').forEach(function (b) {
        b.addEventListener('click', function () { var d = +b.getAttribute('data-d'); show(at + d, d); });
      });
      view.addEventListener('click', function (e) { if (e.target === view && s === 1) close(); });

      /* mouse: click toggles zoom; when zoomed the picture follows the pointer */
      var touched = 0;
      img.addEventListener('click', function (e) {
        if (Date.now() - touched < 700) return;
        if (s > 1) reset(true); else zoomAt(2.5, e.clientX, e.clientY, true);
      });
      img.addEventListener('mousemove', function (e) {
        if (s <= 1 || Date.now() - touched < 700) return;
        var r = view.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width - 0.5, fy = (e.clientY - r.top) / r.height - 0.5;
        var m = (s - 1) * size() / 2;
        tx = -fx * 2 * m; ty = -fy * 2 * m; apply(false);
      });

      /* touch: pinch, pan, double-tap, swipe between shots, swipe down to close */
      var t0 = null, lastTap = 0, mode = '';
      function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
      lb.addEventListener('touchstart', function (e) {
        touched = Date.now();
        if (e.target.closest('.pf2-lb-btn')) { t0 = null; return; }
        var a = e.touches[0];
        if (e.touches.length === 2) {
          var b = e.touches[1];
          t0 = { d: dist(a, b), s: s, cx: (a.clientX + b.clientX) / 2, cy: (a.clientY + b.clientY) / 2 };
          mode = 'pinch';
        } else if (e.touches.length === 1) {
          t0 = { x: a.clientX, y: a.clientY, tx: tx, ty: ty };
          mode = '';
        }
      }, { passive: true });
      lb.addEventListener('touchmove', function (e) {
        if (!t0) return;
        e.preventDefault();
        if (mode === 'pinch') {
          if (e.touches.length === 2) zoomAt(t0.s * dist(e.touches[0], e.touches[1]) / t0.d, t0.cx, t0.cy, false);
          return;
        }
        var p = e.touches[0], dx = p.clientX - t0.x, dy = p.clientY - t0.y;
        if (s > 1) { tx = t0.tx + dx; ty = t0.ty + dy; clamp(); apply(false); mode = 'pan'; return; }
        if (!mode && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) mode = Math.abs(dx) > Math.abs(dy) ? 'swipe' : 'down';
        if (mode === 'swipe') {
          img.style.transition = 'none';
          img.style.transform = 'translateX(' + dx + 'px)';
        } else if (mode === 'down' && dy > 0) {
          img.style.transition = 'none';
          img.style.transform = 'translateY(' + dy + 'px) scale(' + (1 - Math.min(dy, 300) / 1500) + ')';
          lb.style.opacity = String(1 - Math.min(dy, 300) / 450);
        }
      }, { passive: false });
      lb.addEventListener('touchend', function (e) {
        if (!t0) return;
        if (mode === 'pinch') {
          if (e.touches.length === 0) { t0 = null; mode = ''; if (s < 1.05) reset(true); }
          return;
        }
        var p = e.changedTouches[0], dx = p.clientX - t0.x, dy = p.clientY - t0.y;
        if (mode === 'swipe') {
          if (Math.abs(dx) > 60) show(at + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); else apply(true);
        } else if (mode === 'down') {
          lb.style.opacity = '';
          if (dy > 110) close(); else apply(true);
        } else if (!mode && e.target === img) {
          /* a double tap zooms in where it landed, or back out */
          var now = Date.now();
          if (now - lastTap < 320) {
            if (s > 1) reset(true); else zoomAt(2.5, p.clientX, p.clientY, true);
            lastTap = 0;
          } else lastTap = now;
        }
        t0 = null; mode = '';
      });

      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(at + 1, 1);
        else if (e.key === 'ArrowLeft') show(at - 1, -1);
        else if (e.key === 'Tab') {
          /* keep focus inside the dialog */
          var f = [].slice.call(lb.querySelectorAll('button')).filter(function (b) { return b.offsetParent; });
          var i = f.indexOf(document.activeElement);
          if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
        }
      });
    }
    function open(i) {
      var imgs = [].slice.call(stage.querySelectorAll('img'));
      if (!imgs.length) return;
      if (!lb) build();
      urls = imgs.map(function (el) { return big(el.currentSrc || el.src); });
      img.alt = imgs[0].alt || '';
      back = document.activeElement;
      document.documentElement.style.overflow = 'hidden';
      lb.style.display = 'flex';
      show(Math.max(0, i));
      void lb.offsetWidth;
      lb.classList.add('on');
      isOpen = true;
      lb.querySelector('.pf2-lb-x').focus({ preventScroll: true });
    }
    function close() {
      if (!lb || !isOpen) return;
      isOpen = false;
      lb.classList.remove('on');
      lb.style.opacity = '';
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!isOpen) lb.style.display = 'none'; }, reduce ? 0 : 250);
      if (back && back.focus) back.focus({ preventScroll: true });
    }
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('role', 'button');
    stage.setAttribute('aria-label', 'Zoom into the product images');
    stage.addEventListener('click', function (e) {
      if (!e.target.closest('img')) return;
      var imgs = [].slice.call(stage.querySelectorAll('img'));
      open(imgs.indexOf(stage.querySelector('img.show')));
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (stage.querySelector('video.show')) return;
      e.preventDefault();
      var imgs = [].slice.call(stage.querySelectorAll('img'));
      open(imgs.indexOf(stage.querySelector('img.show')));
    });
  })();

  function later() { setTimeout(paint, 0); }
  pdp.addEventListener('click', function (e) {
    if (e.target.closest('[data-pf2-opts] button')) later();
  });
  pdp.addEventListener('change', function (e) {
    if (e.target.closest('[data-pf2-opts]')) later();
  });

  paint();
})();
